import "@arco-design/web-react/es/Modal/style";
import _Modal from "@arco-design/web-react/es/Modal";
import "@arco-design/web-react/es/Space/style";
import _Space from "@arco-design/web-react/es/Space";
import "@arco-design/web-react/es/Card/style";
import _Card from "@arco-design/web-react/es/Card";
import "@arco-design/web-react/es/Table/style";
import _Table from "@arco-design/web-react/es/Table";
import _IconRefresh from "@arco-design/web-react/icon/react-icon/IconRefresh";
import "@arco-design/web-react/es/Select/style";
import _Select from "@arco-design/web-react/es/Select";
import "@arco-design/web-react/es/Input/style";
import _Input from "@arco-design/web-react/es/Input";
import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import "@arco-design/web-react/es/Tag/style";
import _Tag from "@arco-design/web-react/es/Tag";
import "@arco-design/web-react/es/Grid/style";
import _Grid from "@arco-design/web-react/es/Grid";
import "@arco-design/web-react/es/Form/style";
import _Form from "@arco-design/web-react/es/Form";
import _IconDragDotVertical from "@arco-design/web-react/icon/react-icon/IconDragDotVertical";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useEffect, useState } from 'react';
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';
import { compNamePkg } from '@/utils/util';
import styles from '@/style/layout.module.less';
import ThirdPayBankIcon from '@/components/ThirdPayBankIcon';

const arrayMoveMutate = (array, from, to) => {
  const startIndex = to < 0 ? array.length + to : to;

  if (startIndex >= 0 && startIndex < array.length) {
    const item = array.splice(from, 1)[0];
    array.splice(startIndex, 0, item);
  }
};

const arrayMove = (array, from, to) => {
  array = [...array];
  arrayMoveMutate(array, from, to);
  return array;
};

const DragHandle = SortableHandle(() => /*#__PURE__*/React.createElement(_IconDragDotVertical, {
  style: {
    cursor: 'move',
    color: '#555'
  }
}));
const SortableWrapper = SortableContainer(props => {
  return /*#__PURE__*/React.createElement("tbody", props);
});
const SortableItem = SortableElement(props => {
  return /*#__PURE__*/React.createElement("tr", props);
});
const {
  useForm
} = _Form;
const {
  Row,
  Col
} = _Grid; // 商户侧管理多个关联子商户, 后续的modal有几个默认尺寸。不再一个功能一个尺寸

function NavBarRelationMchAdmin(props) {
  const {
    show,
    name,
    unShow,
    switchIncome,
    relationMchList,
    setRelationMchList
  } = props;
  const [queryMchList, setQueryMchList] = useState(undefined);
  const [formRef] = useForm();
  const columns = [{
    title: '展现',
    dataIndex: 'order',
    width: 110,
    render: (v, _, i) => /*#__PURE__*/React.createElement("div", null, i <= 2 ? /*#__PURE__*/React.createElement(_Tag, {
      color: "green"
    }, "\u7F6E\u9876") : /*#__PURE__*/React.createElement(_Tag, null, "\u9690\u85CF")) // render: v => <div>{v <= 2 ? <Tag color="green">置顶</Tag>:<div><Tag>隐藏</Tag>&nbsp;<Button shape='circle' type='default' size="mini"><IconArrowRise /></Button></div>}</div>,

  }, // {
  //     title: 'id',
  //     dataIndex: 'id',
  //     width:100,
  // },
  {
    title: '虚拟户银行',
    dataIndex: 'vb',
    render: v => /*#__PURE__*/React.createElement(ThirdPayBankIcon, {
      tag: v
    }),
    width: 150
  }, {
    title: '关联商户名称',
    dataIndex: 'reg_name',
    render: (v, row) => /*#__PURE__*/React.createElement("div", null, row.archive ? /*#__PURE__*/React.createElement("span", {
      style: {
        color: 'red'
      }
    }, "(\u5DF2\u5F52\u6863)") : '', v)
  }, {
    title: '操作',
    dataIndex: 'id',
    render: (id, row) =>
    /*#__PURE__*/
    //todo 是否开放商户自己归档。
    React.createElement(_Button, {
      type: "text",
      style: {
        marginLeft: -14
      },
      onClick: () => gotoSubIncome(id),
      disabled: row.archive
    }, "\u524D\u5F80"),
    width: 100
  }];

  function onSortEnd({
    oldIndex,
    newIndex
  }) {
    if (oldIndex !== newIndex) {
      const newData = arrayMove([].concat(relationMchList), oldIndex, newIndex).filter(el => !!el);
      console.log('New Data: ', newData);
      const configOrder = [];

      for (const i in newData) {
        configOrder.push(newData[i].id);
      }

      localStorage.setItem('config.order', JSON.stringify(configOrder));
      setRelationMchList(newData);
    }
  }

  const DraggableContainer = props => /*#__PURE__*/React.createElement(SortableWrapper, _extends({
    useDragHandle: true,
    onSortEnd: onSortEnd,
    helperContainer: () => document.querySelector('.arco-drag-table-container-2 table tbody'),
    updateBeforeSortStart: ({
      node
    }) => {
      const tds = node.querySelectorAll('td');
      tds.forEach(td => {
        td.style.width = td.clientWidth + 'px';
      });
    }
  }, props));

  const DraggableRow = props => {
    const {
      record,
      index,
      ...rest
    } = props;
    return /*#__PURE__*/React.createElement(SortableItem, _extends({
      index: index
    }, rest));
  };

  const components = {
    header: {
      operations: ({
        selectionNode,
        expandNode
      }) => [{
        node: /*#__PURE__*/React.createElement("th", null),
        width: 40
      }, {
        name: 'expandNode',
        node: expandNode
      }, {
        name: 'selectionNode',
        node: selectionNode
      }]
    },
    body: {
      operations: ({
        selectionNode,
        expandNode
      }) => [{
        node: /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "arco-table-cell"
        }, /*#__PURE__*/React.createElement(DragHandle, null))),
        width: 40
      }, {
        name: 'expandNode',
        node: expandNode
      }, {
        name: 'selectionNode',
        node: selectionNode
      }],
      tbody: DraggableContainer,
      row: DraggableRow
    }
  };

  const gotoSubIncome = id => {
    switchIncome(id);
  };

  const subMchChangeQuery = v => {
    // console.log(v)
    const hitList = [];

    for (const i in relationMchList) {
      let hit = undefined;

      if (v.mch_name) {
        console.log('查商户');

        if (relationMchList[i].reg_name.indexOf(v.mch_name) > -1) {
          hit = relationMchList[i];
        }

        if (relationMchList[i]['archive'] != v['archive']) {
          hit = undefined;
        }
      } else {
        if (relationMchList[i]['archive'] == v['archive']) {
          hit = relationMchList[i];
        }
      }

      if (hit) {
        hitList.push(hit);
      }
    } // if (!v.mch_name && v.archive == '0') hitList = undefined;
    // console.log(hitList)


    setQueryMchList(hitList);
  };

  useEffect(() => {
    formRef.setFieldsValue({
      mch_name: undefined,
      archive: '0'
    });
    subMchChangeQuery({
      mch_name: undefined,
      archive: '0'
    });
  }, []);
  return /*#__PURE__*/React.createElement("div", null, show ? /*#__PURE__*/React.createElement(_Modal, {
    maskClosable: false,
    title: null,
    style: {
      width: '66%'
    },
    visible: true,
    footer: null,
    onCancel: () => {
      unShow();
    }
  }, /*#__PURE__*/React.createElement(_Card, {
    title: compNamePkg(name)
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_Form, {
    onChange: v => subMchChangeQuery(formRef.getFieldsValue()),
    form: formRef,
    labelAlign: "left"
  }, /*#__PURE__*/React.createElement(Row, {
    gutter: 20
  }, /*#__PURE__*/React.createElement(Col, {
    span: 10
  }, /*#__PURE__*/React.createElement(_Form.Item, {
    label: "\u5546\u6237\u540D\u79F0",
    field: "mch_name"
  }, /*#__PURE__*/React.createElement(_Input, {
    placeholder: "\u8BF7\u8F93\u5165\u67E5\u8BE2\u5546\u6237"
  }))), /*#__PURE__*/React.createElement(Col, {
    span: 10
  }, /*#__PURE__*/React.createElement(_Form.Item, {
    label: "\u5F52\u6863\u72B6\u6001",
    field: "archive"
  }, /*#__PURE__*/React.createElement(_Select, {
    placeholder: "\u8BF7\u9009\u62E9\u72B6\u6001"
  }, /*#__PURE__*/React.createElement(_Select.Option, {
    key: "0",
    value: "0"
  }, "\u4F7F\u7528\u4E2D"), /*#__PURE__*/React.createElement(_Select.Option, {
    key: "1",
    value: "1"
  }, "\u5DF2\u5F52\u6863")))), /*#__PURE__*/React.createElement(Col, {
    span: 4
  }, /*#__PURE__*/React.createElement(_Button, {
    icon: /*#__PURE__*/React.createElement(_IconRefresh, null),
    onClick: () => {
      formRef.setFieldsValue({
        mch_name: undefined,
        archive: '0'
      });
      subMchChangeQuery(formRef.getFieldsValue());
    }
  }, "\u91CD\u7F6E"))))), /*#__PURE__*/React.createElement(_Table, {
    className: "arco-drag-table-container-2",
    size: "small",
    rowKey: "id",
    components: queryMchList ? null : components,
    columns: columns,
    scroll: {
      y: 600,
      x: true
    },
    data: queryMchList ? queryMchList : relationMchList,
    pagination: false
  })), /*#__PURE__*/React.createElement("div", {
    className: styles['button-group']
  }, /*#__PURE__*/React.createElement(_Space, null), /*#__PURE__*/React.createElement(_Space, null, /*#__PURE__*/React.createElement(_Button, {
    onClick: unShow
  }, "\u53D6\u6D88"), /*#__PURE__*/React.createElement(_Button, {
    type: "primary",
    onClick: unShow
  }, "\u786E\u5B9A")))) : null);
}

export default NavBarRelationMchAdmin;